export const N68_Top10 = {
  "columns": 5,
  "rows": 1,
  "visual": {
    "id": 1,
    "type": "combo",
    "colorTheme": 'colorTheme2',
    "title": "Top Performing District Managers (Sales vs Target)",
    "orientation": "vertical",
    "xAxis": "",
    "yAxis": "Performance",
    "binding": {
      "data": {
        "series": [
                    {
                        "name": 'Sales',
                        "value": 'ActualSales',
                        "type": 'column'
                    },
                    {
                        "name": 'Performance %',
                        "value": 'Performance',
                        "type": 'line',
                        "percent": true
                    }
        ],
        "title": "DistrictManagerName",
        "endpoint": "N68.34",
        "parameters": [
          { "key": "FromMonth", "value": "2024" },
          { "key": "FromYear", "value": "1" },
          { "key": "ToMonth", "value": "2024" },
          { "key": "ToYear", "value": "1" },
          { "key": "ConfigTypeCode", "value": "" }
        ]
      },
      "context": {
        "point": {
          "onClick": {
              "selectedValueColumn": "DistrictRegionCode",
              "selectedTitle": "Territory Manager",
              "visual": [
                  {
                      "columns": 12,
                      "rows": 2.5,
                      "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "Territory Manager",
                          "binding": {
                              "data": {
                                  "columns": [
                                      {
                                          "name": 'Territory Code',
                                          "columnName": 'AgentCode',
                                          "width": '200px',
                                          "align": "left",
                                          "sortable": true,
                                          "sum": false,
                                      },                                                      
                                      {
                                          "name": 'Territory Manager Name',
                                          "columnName": 'AgentName',
                                          "width": '230px',
                                          "align": "left",
                                          "sortable": true,
                                          "sum": false,
                                      },
                                      {
                                          "name": 'Territory Name',
                                          "columnName": 'TerritoryName',
                                          "width": '480px',
                                          "align": "left",
                                          "sortable": true,
                                          "sum": false,
                                      },
                                      {
                                          "name": 'District Manager Name',
                                          "columnName": 'DistrictManagerName',
                                          "width": '230px',
                                          "align": "left",
                                          "sortable": true,
                                          "sum": false,
                                      },
                                      {
                                          "name": 'Target',
                                          "columnName": 'TargetSales',
                                          "width": '125px',
                                          "align": "right",
                                          "sortable": true,
                                          "sum": true,
                                      },
                                      {
                                          "name": 'Actual Sales',
                                          "columnName": 'ActualSales',
                                          "width": '140px',
                                          "align": "right",
                                          "sortable": true,
                                          "sum": true,
                                      },
                                      {
                                          "name": 'Performance %',
                                          "columnName": 'Performance',
                                          "width": '180px',
                                          "align": "right",
                                          "sortable": true,
                                          "sum": false,
                                          "percent": true
                                      }
                                  ],
                                  "title": 'AgentName',
                                  "endpoint": "N68.35",
                                  "parameters": [
                                      { "key": "FromMonth", "value": "2024" },
                                      { "key": "FromYear", "value": "1" },
                                      { "key": "ToMonth", "value": "2024" },
                                      { "key": "ToYear", "value": "1" },
                                      { "key": "DistrictRegionCode", "value": "" },
                                      { "key": "RegionCode", "value": "" },                                      
                                      { "key": "ConfigTypeCode", "value": "" }
                                  ]
                              },
                              "context": {
                              "point": {
                              "onClick": {
                                 }
                                }
                              }
                          }
                      }
                  }
              ]
          }
        }
      }
    }
  }
}